// created by LinWeiLong @ 2017/09/12

import axios from 'axios';
import APIS from '../../apis';

import  {callbackHandler} from '../callbackHandler';
;import {isEmpObj} from '../../lib/units'

export default {
    state: {
        [`SEARCH_KEYWORD`]: '',
        [`SEARCHED_WORD`]: '',
        [`SEARCH_RELATED_WORDS`]: [],
        [`SEARCH_RECOMMEND_WORDS`]: [],
        [`SEARCH_RECOMMEND_SCALES`]: {},
        [`SEARCH_RESULT`]: [],
    },
    mutations: {
        [`SET_SEARCH_KEYWORD`]: function(state, payload = '') {
            state.SEARCH_KEYWORD = payload;
        },
        [`SET_SEARCHED_WORD`]: function(state, payload = ''){
            state.SEARCHED_WORD = payload;
        },
        [`SET_SEARCH_RELATED_WORDS`]: function(state, payload = []) {
            payload = isEmpObj(payload)?[]: payload;
            state.SEARCH_RELATED_WORDS = payload;
        },
        [`SET_SEARCH_RECOMEND_WORDS`]: function (state, payload) {
            state.SEARCH_RECOMMEND_WORDS = payload;
        },
        [`SET_SEARCH_RECOMEND_SCALES`]: function (state, payload) {
            state.SEARCH_RECOMMEND_SCALES = payload;
        },
        [`SET_SEARCH_RESULT`]: function(state, payload) {
            state.SEARCH_RESULT = payload;
        }
    },
    getters: {
        [`SEARCH_KEYWORD`]: state => state.SEARCH_KEYWORD,
        [`SEARCHED_WORD`]: state => state.SEARCHED_WORD,
        [`SEARCH_RELATED_WORDS`]: state => state.SEARCH_RELATED_WORDS,
        ['SEARCH_RECOMMEND_WORDS']: state => state.SEARCH_RECOMMEND_WORDS,
        ['SEARCH_RECOMMEND_SCALES']: state => state.SEARCH_RECOMMEND_SCALES,
        [`SEARCH_RESULT`]: state => state.SEARCH_RESULT,
    },
    actions: {
        /**
         *
         * @param context
         * @param params [params.keyword, params.channelId]
         * @param callback
         */
        [`GET_SEARCH_RESULT`]: function (context, {params = {}, callback}) {
            axios.get(APIS.funSearch, {
                params,
            }).then(function (res) {
                //2019/6/28 改成趣味测试和专业测试
                callbackHandler(APIS.funSearch, res, function(DATA){
                    console.log(DATA)
                    context.commit('SET_SEARCH_RELATED_WORDS', []);
                    context.commit('SET_SEARCH_RESULT', DATA.list);
                    if(typeof(callback) == 'function') {
                        callback();
                    }
                });
            })
        },
        /**
         *
         * @param context
         * @param params no params
         * @param callback
         */
        ['GET_SEARCH_RECOMMEND']: function (context, {params = {}, callback = ()=>{}} = {}) {

            axios.get(APIS.searchRecommend, {
                params,
            }).then(function (res) {
                callbackHandler(APIS.funSearch, res, function (DATA) {
                    context.commit('SET_SEARCH_RECOMEND_WORDS', DATA.recommends);
                    context.commit('SET_SEARCH_RECOMEND_SCALES', DATA.scales);
                    callback(DATA);
                });
            })
        },
        /**
         *
         * @param context
         * @param params no params
         * @param callback
         */
        [`GET_SEARCH_RELATED_WORDS`]: function (context, {params = {}, callback = ()=>{}} = {}) {
            if(params.keyword == ''){
                context.commit('SET_SEARCH_RELATED_WORDS', []);
            } else {
                axios.get(APIS.funSearch, {
                    params
                }).then((res) => {
                    callbackHandler(APIS.funSearch, res, function(DATA) {
                        var list = DATA.list.map((item) => {
                            return item.name
                        })
                        console.log(list)
                        context.commit('SET_SEARCH_RELATED_WORDS', list);
                        if(typeof(callback) == 'function') {
                            callback(DATA);
                        }
                    });
                })
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/search.js